import clsx from 'clsx';
import React, { FC } from 'react';
import { useDrop } from 'react-dnd';
import { DnDTypes } from 'types/elearning';
import { DragSource, ImageDnd } from '../image-dnd';
import cls from './drop-zone.module.scss';
import { ReactComponent as StatusFailedIcon } from 'assets/images/elearning/topic-status/status_failed.svg';
import { ReactComponent as StatusSuccessIcon } from 'assets/images/elearning/topic-status/status_success.svg';

interface IProps {
    id: string;
    handleDrop: (
        dropzoneId: string,
        elementId: string,
        removeFromPreviousPosition: boolean
    ) => void;
    description: string;
    image_url?: string;
    image: [string, string];
    isCorrect: boolean | undefined
}

export const DropZone: FC<IProps> = ({
    id,
    handleDrop,
    description,
    image_url,
    image,
    isCorrect
}) => {
    const [{ isOver }, dropRef] = useDrop(() => ({
        accept: DnDTypes.MATCH_IMAGE_WITH_DESCRIPTION,
        drop: (item: { draggedElementId: string; source: DragSource }) => {
            handleDrop(
                id,
                item?.draggedElementId,
                item?.source === 'drop-area' ? true : false
            );
        },
        collect: (monitor) => ({
            isOver: !!monitor.isOver(),
            canDrop: !!monitor.canDrop(),
        }),
    }));

    const clsDropzone = clsx(cls.dropzone, {
        [cls.dropzoneOver]: isOver,
        [cls.dropzoneWithImg]: Boolean(image_url),
    });

    const clsContainer = clsx(cls.container, {
        [cls.containerWrong]: isCorrect !== undefined && !isCorrect,
        [cls.containerCorrect]: isCorrect !== undefined &&  isCorrect,
    });

    return (
        <div className={clsContainer}>
            <div ref={dropRef} className={clsDropzone}>
                {image_url ? (
                    <ImageDnd
                        id={image?.[0]}
                        image_url={image_url as string}
                        source="drop-area"
                    />
                ) : (
                    <div className={cls.dashedBoxWrapper}>
                        <div className={cls.dashedBox} />
                    </div>
                )}
            </div>
            <div className={cls.description}>
                { isCorrect === true && isCorrect !== undefined ? (
                    <StatusSuccessIcon className={cls.statusIcon} />
                    ) : isCorrect === false && isCorrect !== undefined ? (
                    <StatusFailedIcon className={cls.statusIcon} />
                    ): ''
                }
                <p>{description}</p>
            </div>
        </div>
    );
};
